import axios from 'axios';
import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import IconSearch from '@material-ui/icons/Search'
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({     
  comboOptions: {
      fontSize: '16px',
      color:'var(--darker)',
      // backgroundColor:'var(--backgroundcolor)'
  },
  inputColor: {
    fontSize: '16px',
    color:'var(--darker)',
    // backgroundColor:'var(--backgroundcolor)'
}
  
}));


let timer;
export default function Asynchronous(props) {
  const [open, setOpen] = React.useState(false);
  const [inputText, setInputText] = React.useState(null);
  const [options, setOptions] = React.useState([])
  const loading = open && options.length === 0 && inputText;
  const classes = useStyles();

 

  const handleChange = async (e) => {
    setInputText(e.target.value)
   
  }

  

  const handleAutocompleteChange = (e, newValue) => {
    if(props.onChange){
      props.onChange(newValue)
    }
  }

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  React.useEffect(() => {  
   if(!inputText||inputText=="")
   setOptions([]);
   else
    doSearch()
  }, [inputText]);

  const doSearch=async()=>{
    clearTimeout(timer);
    timer=   setTimeout(async ()=>{
           let response = await axios.get(`hotels/search-cities?q=${inputText}`)
    if (response && response.data && response.data.data) {
      var data = response.data.data
      setOptions(data);
     }
      },500)
  }



  return (
    <>  
    <div className='myautocomplete'> 
    
    <Autocomplete freeSolo={true} PaperComponent={({ children }) => (
          <Paper style={{ background: 'var(--backgroundcolor)' }}>{children}</Paper>
        )}
      id="asynchronous-demo"
      open={open}
      style={{color:'var(--darker)'}}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) => option.city === value.city}
      getOptionLabel={(option) => 
       (option.city + `(${option.state}, ${option.country})`)}
      options={options}
      renderOption={(option) => (
        <Typography className={classes.comboOptions}>  {(option.city + `(${option.state}, ${option.country})`)}</Typography>
    )} inputValue={inputText||""}
      loading={loading}
      onChange={handleAutocompleteChange}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.placeholder}
          fullWidth
          style={{fontSize:'13px',color:'var(--darker)'}}
          // variant="outlined"
          onChange={handleChange}
          InputProps={{
            ...params.InputProps,
            className: classes.inputColor,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="var(--backgroundcolor)" size={20} /> : null}
                  </React.Fragment>
            ),
            startAdornment:(<IconSearch/>)
          }}
        />
      )}
 
    /></div> </>
  );
}

Asynchronous.defaultProps = {
  placeholder:'Type to search'
}

